import { render, staticRenderFns } from "./AnnounceDetailsScreen.vue?vue&type=template&id=d53dcc1a&scoped=true&"
import script from "./AnnounceDetailsScreen.vue?vue&type=script&lang=js&"
export * from "./AnnounceDetailsScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d53dcc1a",
  null
  
)

export default component.exports